export const shapeFlags = {
  Circle: {
    rotate: false,
    flipX: false,
    flipY: false,
  },
  Oval: {
    rotate: false,
    flipX: false,
    flipY: false,
  },
  Rectangle: {
    rotate: false,
    flipX: false,
    flipY: false,
  },
  RoundedRectangle: {
    rotate: false,
    flipX: false,
    flipY: false,
  },
  RoundedThinRectangle: {
    rotate: true,
    flipX: false,
    flipY: false,
  },
  ArrowWithoutTail: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  ArrowCommon: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  ArrowFull: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  ArrowThin: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  Triangle: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  Trapeze1: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  Trapeze2: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  Trapeze3: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  LongTriangle: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  Quarter: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
  CurvedArrow: {
    rotate: true,
    flipX: true,
    flipY: true,
  },
};

export const isTransformationEnabled = (shapeType, transformation) => {
  return shapeFlags[shapeType] && shapeFlags[shapeType][transformation];
};

export const isRotationEnabled = (shapeType) => {
  return isTransformationEnabled(shapeType, "rotate");
};

export const isFlipXEnabled = (shapeType) => {
  return isTransformationEnabled(shapeType, "flipX");
};

export const isFlipYEnabled = (shapeType) => {
  return isTransformationEnabled(shapeType, "flipY");
};
